import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, MenuController, LoadingController, AlertController, Events } from 'ionic-angular';
//import { HomePage } from '../home/home';
import { RegisterPage } from '../register/register';
import { RequestServiceProvider } from '../../providers/request-service/request-service';
import { TabsPage } from '../tabs/tabs';
import { AuthProvider } from '../../providers/auth/auth';
import { ForgetPasswordPage } from '../forget-password/forget-password';
import { EncryptionProvider } from '../../providers/encryption/encryption';
import { ChangePasswordPage } from '../change-password/change-password';
import { AgentPage } from '../agent/agent';





/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  segment:'login'
})
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  private code = window.localStorage.getItem('agentCode');

  agent = {
    ...(this.code? {username:this.code.slice(4)} : {username: ''}),
    password: ''
  }

  public loader;

  constructor(

    public navCtrl: NavController,
    public navParams: NavParams,
    public menu : MenuController,
    private request: RequestServiceProvider,
    private auth: AuthProvider,
    private loading: LoadingController,
    private alertCtrl: AlertController,
    private encrypt: EncryptionProvider,
    private event: Events

  ) {
        
        this.menu.enable(false);
        this.menu.swipeEnable(false);
       
  }

login(FormLogin){
  this.presentLoading()

 // console.log(FormLogin.value.password)

  let encryptedPassword = this.encrypt.makeSha(FormLogin.value.password)

 // console.log(encryptedPassword);

  this.request.login(FormLogin.value.username,encryptedPassword)

  .subscribe(data => {


    if(data.status == 200 && data.headers.get("Authorization") != null ){

    // console.log(data.json())

      window.localStorage.setItem('token', data.headers.get("Authorization"));

      window.localStorage.setItem('session',data.headers.get('X-SessionID'));

      this.loader.dismiss().catch(()=>{});

      if(data.json().firstTime == "true"){

        this.navCtrl.setRoot(ChangePasswordPage);

      }else{

       this.navCtrl.setRoot(TabsPage);

      }


    }
  },
  error => {

  //  console.log(error.json().message);

    this.loader.dismiss().catch(()=>{});

    FormLogin.password = "";

    this.presentAlert(error.json().message);

  })
}

presentAlert(message){
  let alert = this.alertCtrl.create({
    title:"Login Failed",
    subTitle:message,
    buttons:['RETRY']
  })
  alert.present();
}

  getAuthUser(){
    this.presentLoading();

 // this.request.authToken();

  if(this.request.loggedIn()){
    this.navCtrl.setRoot(TabsPage);
  }
  this.loader.dismiss().catch(()=>{});

  }

  getRequest(){
    this.request.getInfo().subscribe(data => console.log(data));
    //this.request.getInfo();
  }

  presentLoading(){
    this.loader = this.loading.create({
      content:"Authenticating..."
    })
    this.loader.present();
  }


  goTolanding() {
    this.navCtrl.setRoot(TabsPage);
  }

  goToRegisterPage() {
  //  this.navCtrl.push(RegisterPage);
  this.navCtrl.push(AgentPage);
  }
  goToPasswordReset(){
    this.navCtrl.push(ForgetPasswordPage);
  }

  ionViewWillLoad() {

   /*  console.log(window.localStorage.getItem('agentCode'))
    this.FormLogin.username = window.localStorage.getItem('agentCode')
    
    if(window.localStorage.getItem('agentCode') !== '' && window.localStorage.getItem('agentCode') !== null) {
      this.FormLogin.username = window.localStorage.getItem('agentCode')
    } */
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LoginPage');

  }
  ionViewWillLeave(){
    this.menu.enable(true);
    this.menu.swipeEnable(true);
    }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts